module.exports = __webpack_public_path__ + "static/media/Tyrrells-192x192.9da01455.png";